var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnErrorDetailinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.917h2.125v-9.584H19Zm1-12.292q.5 0 .854-.354t.354-.854q0-.542-.354-.875-.354-.334-.854-.334t-.854.334q-.354.333-.354.875 0 .5.354.854t.854.354Zm0 20.208q-3.292 0-6.167-1.25t-5.021-3.395q-2.145-2.146-3.395-5.021T4.167 20q0-3.292 1.25-6.187 1.25-2.896 3.395-5.021 2.146-2.125 5.021-3.375T20 4.167q3.292 0 6.188 1.25 2.895 1.25 5.02 3.375 2.125 2.125 3.375 5.021 1.25 2.895 1.25 6.187 0 3.292-1.25 6.167t-3.375 5.021q-2.125 2.145-5.02 3.395-2.896 1.25-6.188 1.25Zm0-2.083q5.75 0 9.75-4.021t4-9.729q0-5.75-4-9.75t-9.75-4q-5.708 0-9.729 4-4.021 4-4.021 9.75 0 5.708 4.021 9.729Q14.292 33.75 20 33.75ZM20 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnErrorDetailinfo);
export default __webpack_public_path__ + "static/media/conn-error-detailinfo.9b134dee69089ae0fa8796d072c630a9.svg";
export { ForwardRef as ReactComponent };